window.onload = function() {
    var titleElements = document.querySelectorAll('.product-tile__title a');

    // titleElements.forEach(function(titleElem) {
    //     if (titleElem.textContent.includes(" TRUE WIRELESS")) {
    //         // テキストを「TRUE WIRELESS」で分割
    //         var parts = titleElem.textContent.split(" TRUE WIRELESS");

    //         // 分割した部分を組み立て直して、前の部分を<span>で囲む
    //         titleElem.innerHTML = '<span class="product-series-title">' + parts[0] + '</span><br>TRUE WIRELESS' + parts[1];
    //     }
    //     else if (titleElem.textContent.includes(" ON-EAR")) {
    //         // テキストを「TRUE WIRELESS」で分割
    //         var parts = titleElem.textContent.split(" ON-EAR");

    //         // 分割した部分を組み立て直して、前の部分を<span>で囲む
    //         titleElem.innerHTML = '<span class="product-series-title">' + parts[0] + '</span><br>ON-EAR' + parts[1];
    //     }
    //     else if (titleElem.textContent.includes("REWIND WIRELESS")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("REWIND WIRELESS", '<span class="product-series-title">REWIND WIRELESS</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("JBUDS PROTECT")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("JBUDS PROTECT", '<span class="product-series-title">JBUDS PROTECT</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("JBUDDIES PROTECT")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("JBUDDIES PROTECT", '<span class="product-series-title">JBUDDIES PROTECT</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("NIGHTFALL")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("NIGHTFALL", '<span class="product-series-title">NIGHTFALL</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("EPIC LAB EDITION")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("EPIC LAB EDITION", '<span class="product-series-title">EPIC LAB EDITION</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("JBUDDIES PRO WIRED")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("JBUDDIES PRO WIRED", '<span class="product-series-title">JBUDDIES PRO WIRED</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("JBUDDIES FOLDING")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("JBUDDIES FOLDING", '<span class="product-series-title">JBUDDIES FOLDING</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("JBUDS ANC 3")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("JBUDS ANC 3", '<span class="product-series-title">JBUDS ANC 3</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("JBUDS LUX ANC")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("JBUDS LUX ANC", '<span class="product-series-title">JBUDS LUX ANC</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("FLEX")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("FLEX", '<span class="product-series-title">FLEX</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("REWIND 2 WIRELESS")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("REWIND 2 WIRELESS", '<span class="product-series-title">REWIND 2 WIRELESS</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("JBUDS OPEN SPORT")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("JBUDS OPEN SPORT", '<span class="product-series-title">JBUDS OPEN SPORT</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("EPIC SPORT ANC 3")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("EPIC SPORT ANC 3", '<span class="product-series-title">EPIC SPORT ANC 3</span><br>');
    //     }
    //     else if (titleElem.textContent.includes("EPIC OPEN SPORT")) {
    //         // 区切り用文字が商品名の1文字目からのため、replaceを使用
    //         titleElem.innerHTML = titleElem.innerHTML.replace("EPIC OPEN SPORT", '<span class="product-series-title">EPIC OPEN SPORT</span><br>');
    //     }
    //     else {
    //     }
    // });
};
